import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar'
import Breadcrumb from "../common/breadcrumb";
import NewProduct from "../common/new-product";
import Filter from "./common/filter";
import FilterBar from "./common/filter-bar";
import ProductListing from "./common/product-listing";
import ProductLists from "./common/product-lists";
import ProductVariants from "./common/product-variants";
import StickyBox from "react-sticky-box";
import Paystar from "../../assets/icon/paystar.svg"
import Zarinpal from "../../assets/images/zarinpal.png"
import Parsian from "../../assets/images/parsian.png"
import GiftCard2 from "../../assets/images/giftcard2.jpg"
import GiftCard1 from "../../assets/images/giftcard3.jpg"
import { GetGiftCardCategories, GetGiftCardProducts, RequestGiftCardPayment, GetGiftCardCategory } from '../../services/api';
import Swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import Pace from 'react-pace-progress'
import Modal from 'react-responsive-modal';
import TopBarProgress from "react-topbar-progress-indicator";

TopBarProgress.config({
    barColors: {
        "0": "#2757ae",
        "1.0": "#2757ae"
    },
    shadowBlur: 5
});


class CollectionLeftSidebar extends Component {
    constructor(props) {
        super(props);
        this.selectProduct = this.selectProduct.bind(this)
        this.selectRegion = this.selectRegion.bind(this)
        this.selectVariant = this.selectVariant.bind(this)
        this.payment = this.payment.bind(this);
    };
    state = {
        layoutColumns: 3,
        quantity: 1,
        stock: 'InStock',
        metaTitle: '',
        isLoading: true,
        searchText: '',
        // maion products
        loading: false,
        products: [],
        checkRule: false,
        giftCardCategory: '',
        // first step
        loadingProducts: false,
        ipgType: 'parsian',
        goToPaymentLoading: false,
        selectedProduct: null,
        selectedProductName: null,

        // second step
        loadingRegion: false,
        selectedRegion: null,

        // third step
        loadingVariant: false,
        selectedVariant: null,
        open: false
    }
    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };
    async componentDidMount() {

        this.setState(state => ({ ...state, loading: true }));
        this.setState({ isLoading: true });
        let products = []
        if (!localStorage.getItem('products')) {
            products = (await GetGiftCardCategories()).data;
            localStorage.setItem('products', JSON.stringify(products))
        } else {
            products = JSON.parse(localStorage.getItem('products'))
        }
        const searchParams = new URLSearchParams(this.props.location.search);
        const id = searchParams.get('id');
        this.setState(state => ({ ...state, products, }));
        this.setState(state => ({ ...state, loading: false }));
        this.setState({ isLoading: false });
        if (id) {
            this.selectProduct(products.find(product => product.id === id));
        }
    };
    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            const searchParams = new URLSearchParams(prevProps.history.location.search);
            const id = searchParams.get('id');
            if (id && (this.state.products, this.state.selectedProduct)) {
                this.selectProduct(this.state.products.find(product => product.id === id));
            }
        }
    }

    async selectProduct(product) {
        this.setState(state => ({ ...state, loadingProducts: true }))
        if (!product) {
            return;
        }
        const id = product.id
        this.state.metaTitle = product.meta_title

        let selectedProduct = (await GetGiftCardProducts({ id })).data.data;

        this.setState(state => ({ ...state, selectedProduct, selectedProductName: product.title, selectedRegion: null, selectedVariant: null, giftCardCategory: giftCard }));
        setTimeout(() => {
            document.getElementById('select-regions').scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100);
        let giftCard = await GetGiftCardCategory(id)
        this.setState(state => ({ ...state, giftCardCategory: giftCard.data.response.categoryDescription, loadingProducts: false }));

    };
    async selectRegion(product) {
        this.setState(state => ({ ...state, selectedRegion: product, selectedVariant: null }));
        setTimeout(() => {
            document.getElementById('select-variant').scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100);
    };
    setPrice = (price) => {
        let p = Math.round(price + (price * (0 / 100)))
        return p.toLocaleString()
    }
    setFinalPrice = (price) => {
        let p = Math.round(price + (price * (0 / 100)))
        return (p * this.state.quantity).toLocaleString()
    }
    setTotalPrice = (price) => {
        let p = Math.round(price + (price * (0 / 100)))
        return (p * this.state.quantity)
    }
    async selectVariant(product) {

        this.setState(state => ({ ...state, selectedVariant: product }));
        setTimeout(() => {
            document.getElementById('select-payment').scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100);
    };

    async payment() {
        let userInfo = localStorage.getItem('user_info');
        if (!userInfo) {
            Swal.fire({
                icon: "warning",
                title: "ابتدا وارد شوید",
                showConfirmButton: false,
                timer: 3000
            })
            this.props.history.push('/pages/login?callback=' + window.location.pathname + window.location.search);
            return;
        }
        else if (!this.state.checkRule) {
            Swal.fire({
                icon: "warning",
                title: "قوانین و مقررات را مطالعه و تایید نمایید.",
                showConfirmButton: false,
                timer: 3000
            })
        } else if (this.state.ipgType === '') {
            Swal.fire({
                icon: "warning",
                title: "لطفا درگاه پرداخت مورد نظر را انتخاب نمایید.",
                showConfirmButton: false,
                timer: 3000
            })
        } else {
            this.setState(state => ({ ...state, goToPaymentLoading: true }));
            userInfo = JSON.parse(userInfo);
            let token = Math.random().toString();

            let data = {
                amount: this.setTotalPrice(this.state.selectedVariant.price) * 10,
                variantId: this.state.selectedVariant.id,
                productId: this.state.selectedRegion.product_id,
                categoryId: this.state.selectedProduct.id,
                customerId: userInfo.customerID,
                ipgType: this.state.ipgType,
                productName: this.state.selectedRegion.name + `(${this.state.selectedVariant.title})`,
                count: this.state.quantity,
                callBackUrl: `${window.location.origin}/payment/result?token=${token}`,
            };
            await RequestGiftCardPayment(data).then((response) => {
                localStorage.setItem('callback-token-' + token, response.data.response.token);
                localStorage.setItem('callback-variant-' + token, this.state.selectedVariant.id);
                this.setState(state => ({ ...state, goToPaymentLoading: false }));
                Swal.fire({
                    icon: "info",
                    title: "در حال انتقال به درگاه",
                    showConfirmButton: false,
                    timer: 3000
                })
                window.location.replace(response.data.response.url);
            });
        }


    };
    minusQty = () => {
        if (this.state.quantity > 1) {
            // this.setState({ stock: 'InStock' })
            this.setState({ quantity: this.state.quantity - 1 })
        }
    }

    plusQty = () => {
        // if (this.props.item.stock >= this.state.quantity) {
        this.setState({ quantity: this.state.quantity + 1 })
        // } else {
        // this.setState({ stock: 'Out of Stock !' })
        // }
    }
    changeQty = (e) => {
        this.setState({ quantity: parseInt(e.target.value) })
    }
    LayoutViewClicked(colums) {
        this.setState({
            layoutColumns: colums
        })
    }
    readMore = () =>  {
       let element =  document.getElementsByClassName('des-product')
       element.item(0).style.whiteSpace = 'unset'
    }
    changeCheckRule = (e) => {
        this.setState({ checkRule: e.target.checked })
    }

    openFilter = () => {
        document.querySelector(".collection-filter").style = "left: -15px";
    }
    searchProduct = () => {
        let product = JSON.parse(localStorage.getItem('products'))
        let pro = []
        this.setState((old) => ({ ...old, selectedRegion: null, selectedProduct: null, selectedVariant: null }))

        product.map(el => {
            if (el.title.includes(this.state.searchText)) {
                pro.push(el)
            }
        })
        this.setState((old) => ({ ...old, products: pro }));
    }
    onInputSearchProduct = (text) => {
        let product = JSON.parse(localStorage.getItem('products'))

        setTimeout(() => {
            let pro = []
            this.setState((old) => ({ ...old, selectedRegion: null, selectedProduct: null, selectedVariant: null }))

            product.map(el => {
                if (el.title.includes(text)) {
                    pro.push(el)
                }
            })
            this.setState((old) => ({ ...old, products: pro }));
        }, 1000);

    }

    render() {
        return (
            <div>
                {/* <img src={GiftCard1}/>  */}

                {/* <Breadcrumb title={'گیفت کارت'} /> */}
                {/*SEO Support*/}
                <Helmet>
                    <title>ایزی کارت 724 | گیفت کارت ها</title>
                    <meta name="description" content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses." />
                </Helmet>


                {/*SEO Support End */}
                <div></div>
                <section className="section-b-space pt-2">
                    <div className="form_search mx-auto" role="form">
                        <input id="query search-autocomplete" type="search"
                            value={this.state.searchText}
                            onChange={(e) => this.setState({ searchText: e.target.value })}
                            placeholder="جستجو گیفت کارت ها"
                            onInput={(e) => this.onInputSearchProduct(e.target.value)}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    this.searchProduct()
                                }
                            }}
                            className="nav-search nav-search-field" aria-expanded="true" />
                        <button onClick={this.searchProduct} className="btn-search">
                            <i className="fa fa-search"></i>
                        </button>
                    </div>
                    <div className="collection-wrapper">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-0 collection-filter">

                                    <StickyBox offsetTop={20} offsetBottom={20}>
                                        <div>
                                            {/* <Filter /> */}
                                            {/* <NewProduct /> */}
                                            {/* <div className="collection-sidebar-banner">
                                                <a href="#">
                                                <img src={`${process.env.PUBLIC_URL}/assets/images/side-banner.png`} className="img-fluid" alt="" />
                                                    </a>
                                                </div> */}
                                        </div>
                                    </StickyBox>
                                    {/*side-bar banner end here*/}
                                </div>
                                <div className="collection-content col">
                                    <div className="page-main-content ">
                                        <div className="">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    {/* <div className="top-banner-wrapper">
                                                        <a href="#"><img src={`${process.env.PUBLIC_URL}/assets/images/mega-menu/2.jpg`} className="img-fluid" alt=""/></a>
                                                        <div className="top-banner-content small-section">
                                                        <h4>fashion</h4>
                                                        <h5>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h5>
                                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. </p>
                                                        </div>
                                                    </div> */}
                                                    <div className="collection-product-wrapper">
                                                        {false &&
                                                            <div className="product-top-filter">
                                                                <div className="container-fluid p-0">
                                                                    <div className="row">
                                                                        <div className="col-xl-12">
                                                                            <div className="filter-main-btn">
                                                                                <span onClick={this.openFilter}
                                                                                    className="filter-btn btn btn-theme"><i
                                                                                        className="fa fa-filter"
                                                                                        aria-hidden="true"></i> Filter</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="row">
                                                                    <div className="col-12">
                                                                    <FilterBar onLayoutViewClicked={(colmuns) => this.LayoutViewClicked(colmuns)} />
                                                                    </div>
                                                                </div> */}
                                                                </div>
                                                            </div>
                                                        }

                                                        {/*Products Listing Component*/}
                                                        <div className='first-section-item-box mt-3'>


                                                            <div className='d-flex' style={{ alignItems: 'center', justifyContent: 'start', gap: '5px' }}>
                                                                {/* <span className='step'></span> */}
                                                            </div>
                                                            <ProductLists loading={this.state.isLoading} selectProduct={this.selectProduct} products={this.state.products}
                                                                colSize={this.state.layoutColumns} />
                                                        </div>
                                                        <hr className='mt-5' />
                                                        {this.state.selectedProduct !== null &&
                                                            <>
                                                                <div className='first-section-item-box mt-3' id='select-regions' style={{ paddingTop: '1rem' }}>
                                                                    <div className='d-flex' style={{ alignItems: 'center', justifyContent: 'start', gap: '5px' }}>
                                                                        <span className='step'></span>
                                                                        <span> انواع {this.state.selectedProductName}</span>

                                                                    </div>
                                                                    <div className='description mt-3'>

                                                                        <span className='mb-2'>   <i className="fa fa-info-circle" style={{ color: '#b5b5b5' }}></i> توضیحات سرویس</span>

                                                                        <h6 style={{ fontSize: '17px' }}>{this.state.metaTitle}</h6>
                                                                        <h6 style={{ fontSize: '17px',textAlign:'justify' }}><i class="fa fa-exclamation-triangle" aria-hidden="true" style={{ color: 'red' }}></i><span className='mr-1' style={{ color: 'red' }}>بسیار مهم: </span> ریجن اکانت شما باید با گیفت کارت خریداری شده یکسان باشد و IP کشورها یکی باشد، در صورت اشتباه، وجه پرداختی قابل عودت نمی باشد.</h6>
                                                                        {this.state.giftCardCategory && this.state.giftCardCategory !== '' &&
                                                                            <div className='des-product' onClick={this.readMore}  style={{ fontSize: '15px',textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: (this.state.giftCardCategory) }} >

                                                                            </div>
                                                                        }
                                                                        {/* {this.state.giftCardCategory} */}
                                                                    </div>

                                                                    <ProductListing loading={this.state.loadingProducts} selectRegion={this.selectRegion}
                                                                        products={this.state.selectedProduct.data} colSize={this.state.layoutColumns} />

                                                                </div>
                                                                {!this.state.isLoading && <hr className='mt-5' />}
                                                            </>
                                                        }
                                                        {this.state.selectedRegion !== null &&
                                                            <>
                                                                <div className='first-section-item-box mt-3' id='select-variant' style={{ paddingTop: '1rem' }}>
                                                                    <div className='d-flex' style={{ alignItems: 'center', justifyContent: 'start', gap: '5px' }}>
                                                                        <span className='step'></span>
                                                                        <span>انتخاب مبلغ</span>
                                                                    </div>
                                                                    <ProductVariants selectVariant={this.selectVariant} products={this.state.selectedRegion.variants}
                                                                        parentProduct={this.state.selectedRegion} colSize={this.state.layoutColumns} />
                                                                </div>
                                                                {!this.state.isLoading && <hr className='mt-5' />}
                                                            </>
                                                        }
                                                        {this.state.selectedVariant !== null &&
                                                            <div className='first-section-item-box mt-3' id='select-payment' style={{ paddingTop: '1rem' }}>
                                                                <div className='d-flex' style={{ alignItems: 'center', justifyContent: 'start', gap: '5px' }}>
                                                                    <span className='step'></span>
                                                                    <span>تسویه حساب و خرید گیفت کارت</span>
                                                                </div>
                                                                <div className="row mx-2" style={{ gap: '1rem' }}>

                                                                    <div className='col-md-7 col-sm-12 col-lg-7 tree-section p-3 mx-auto'> <div className=''>
                                                                        <h4 className='text-center'>{this.state.selectedRegion.name}<span className='mr-1' style={{ fontSize: '15px' }}>({this.state.selectedVariant.title})</span></h4>
                                                                    </div>
                                                                        {/* <div className='display-flex mt-4'>
                                                                            <h6 className='text-center'>تعداد :</h6>
                                                                            <div className="qty-box">
                                                                                <div className="input-group">
                                                                                    <span className="input-group-prepend">
                                                                                        <button type="button" className="btn quantity-left-minus" onClick={this.minusQty} data-type="minus" data-field="">
                                                                                            <i className="fa fa-minus" style={{ color: 'red' }}></i>
                                                                                        </button>
                                                                                    </span>
                                                                                    <input type="text" name="quantity" value={this.state.quantity}
                                                                                        // onChange={this.changeQty}
                                                                                        className="form-control input-number" />
                                                                                    <span className="input-group-prepend">
                                                                                        <button type="button" className="btn quantity-right-plus" onClick={this.plusQty} data-type="plus" data-field="">
                                                                                            <i className="fa fa-plus" style={{ color: 'green' }}></i>
                                                                                        </button>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div> */}
                                                                        <hr />
                                                                        {/* <div className='display-flex mt-4'>
                                                                            <h6 className='text-center'>قیمت واحد :</h6>
                                                                            <h6>{this.setPrice(this.state.selectedVariant.price)} تومان</h6>
                                                                        </div>
                                                                        <hr /> */}
                                                                        <div className='display-flex mt-4'>
                                                                            <h6 className='text-center'>قیمت نهایی :</h6>
                                                                            <h5 style={{ color: 'red' }}>{this.setFinalPrice(this.state.selectedVariant.price)} تومان</h5>
                                                                        </div>
                                                                        <hr />


                                                                        <div className='text-center'>
                                                                            {this.state.goToPaymentLoading &&


                                                                                <TopBarProgress />

                                                                            }
                                                                            <div className='pay-img mt-5'>
                                                                                <img className={this.state.ipgType == 'parsian' ? 'active-payment' : ''} style={{ maxWidth: '100px', cursor: 'pointer' }} src={Parsian} alt="" onClick={(e) => this.setState((old) => ({ ...old, ipgType: 'parsian' }))} />
                                                                                <div style={{ marginTop: '24px' }}>
                                                                                    <img className={this.state.ipgType == 'zarin' ? 'active-payment' : ''} style={{ maxWidth: '100px', cursor: 'pointer' }} src={Zarinpal} alt="" onClick={(e) => this.setState((old) => ({ ...old, ipgType: 'zarin' }))} />
                                                                                    <h6 style={{ color: 'red', fontSize: '12px' }}>کارمزد درگاه با مشتری</h6>

                                                                                </div>
                                                                            </div>
                                                                            <div className='d-flex text-center mt-2' style={{ justifyContent: 'center', alignItems: 'center' }}>

                                                                                <div className="shopping-option text-center ml-2" style={{ cursor: 'pointer' }}>
                                                                                    <input type="checkbox" name="free-shipping" checked={this.state.checkRule} id="free-shipping" onChange={this.changeCheckRule} />
                                                                                </div>
                                                                                <h6 onClick={this.onOpenModal} style={{ color: '#0075dc', cursor: 'pointer' }}>قوانین و مقررات </h6>
                                                                                <label className='mr-2' htmlFor="free-shipping">را مطالعه نموده ام.</label>
                                                                            </div>

                                                                            <button onClick={this.payment} className='btn btn-primary w-50 mt-2' >پرداخت</button>
                                                                        </div>



                                                                    </div>
                                                                    {/* <div className='col-md-4 col-sm-12 col-lg-4 tree-section text-center'> */}


                                                                    {/* <span>   <i className="fa fa-info-circle" style={{ color: '#b5b5b5' }}></i> توضیحات سرویس</span>
                                                                        <p className='text-center mt-5' style={{ lineHeight: '25px' }}>گیفت کارت Giftcard، کارتی است که می‌توانید از آن برای خرید از سایت‌های خارجی و شارژ اکانت‌های مختلف استفاده کنید. ایرانیکارت با ۱۳ سال سابقه فعالیت، معتبرترین سایت خرید گیفت کارت در ایران است. شما می‌توانید برای خرید گیفت کارت از هر نوعی که نیاز دارید، از خدمات ایزیکارت استفاده کنید.

                                                                            به راحتی انواع گیفت کارت های مختلف از جمله گیفت کارت های پلی استیشن، ایکس باکس، اپل، فری فایر، آمازون، اسپاتیفای، نتفلیکس و… را با مبالغ مختلف از ایرانیکارت سفارش دهید تا به صورت آنی برای شما ارسال شود.</p>
                                                                    </div> */}
                                                                    {/* </div> */}
                                                                </div>
                                                            </div>
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal open={this.state.open} onClose={this.onCloseModal} center>
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content quick-view-modal">
                            <div className="modal-body mt-5">
                                <div style={{ border: '1px solid #ececec', padding: '10px', borderRadius: '8px', overflow: 'auto', maxHeight: '50vh' }}>
                                    <h4>قوانین و مقررات</h4>
                                    <p className='rules-text'>
                                        این سایت در هیچ شرایطی، مسئولیت خریدهای انجام شده در قبال درخواست مشتری را به عهده نخواهد گرفت و انجام تحقیقات، اطمینان از صحت عملکرد فروشنده، کیفیت و کمیت کالا یا خدمات خریداری شده و شرایط استفاده از آن ها به طور مستقیم به عهده درخواست کننده می باشد و این سایت قادر به بررسی هیچ یک از موارد فوق نخواهد بود.<br /> توزیع کننده و این سایت در هر زمان در رد یا قبول هر سفارش در هر مرحله و به هر دلیل مختار می باشند، بدیهی ست در صورت رد سفارشات توسط این سایت هزینه دریافت شده پس از کسر هزینه های انجام شده مسترد خواهد شد. استرداد هزینه ظرف هفت روزکاری انجام خواهد شد. درخواست کننده، مسئول اصلی سفارشات و پرداخت های صورت گرفته می باشد و می بایست شخصا از تطابق سفارش ارائه شده، با قوانین بین المللی و کشور جمهوری اسلامی ایران اطمینان حاصل نماید و در صورت بروز تخلف کلیه مسئولیت های پاسخگویی در مراجع قانونی بر عهده درخواست کننده می باشد. چنانچه این سایت در هر یک از مراحل انجام سفارش با موارد مشکوک و تخلف مواجه شود، بلافاصله مراتب را به مراجع ذیصلاح انعکاس خواهد داد. این سایت می تواند در هر زمان مفاد تعهدنامه را بدون اعلام قبلی، تغییر داده یا مفادی به آن اضافه یا کسر نماید. محصولات در زمان تحویل کاملاً قابل استفاده و فعال می باشند و در صورت بروز هرگونه مشکل احتمالی حین استفاده، درخواست کننده موظف است موضوع را به پشتیبانی این سایت و یا پشتیبانی محلی (توزیع کننده) اطلاع دهد.<br />تبصره ١: در مواردی که این سایت مشخص کند مشکل بوجود آمده ناشی از موارد مشروحه ذیل باشد، هیچ مسئولیتی نداشته و نه تنها مسئولیت و تعهدی متوجه سایت نمی شود بلکه تمامی عواقب مادی و معنوی آن برعهده مشتری و خریدار می باشد.<br />۱. غیر فعال شدن حساب مشتری به دلیل انجام فعالیت های مالی مشکوک، ارسال پول از منابع ممنوعه و یا نامعلوم<br />۲. استفاده غلط از محصول و یا قصد سوء استفاده از امکانات آن<br />تبصره ٢: در صورت غیر فعال شدن محصول به دلیل تشدید تحریم های بین المللی علیه ایران و یا تغییر قوانین سرویس دهنده در این زمینه، این سایت هیچ گونه مسئولیتی در قبال استرداد هزینه های پرداخت شده و همچنین مبالغ موجود در حساب به مشتری نخواهد داشت.<br />تبصره ٣: محصول ارائه شده جزو اموال این سایت می باشد و این سایت این حق را برای خود محفوظ می داند که در هر زمان که صلاح بداند سرویس و خدمات خود را قطع نموده و استرداد محصول را درخواست نماید. در این صورت درخواست کننده باید سریعاً نسبت به عودت محصول به این سایت اقدام نماید.<br />تبصره ۴: در صورت عدم استفاده یا عدم فعال سازی محصول، مسئولیت عدم استفاده پس از مدت مشخص شده که در اینجا یک ماه در نظر گرفته شده است برعهده مشتری یا خریدار می باشد. استفاده از محصول شامل پرداخت هزینه های اعلام شده توسط سایت و همچنین تولید کننده محصول می باشد. کاربر محصول موظف است در صورت سرقت و یا مفقود شدن آن مراتب را هر چه سریع تر به تولید کننده اطلاع دهد. سایت هیچ تعهدی مبنی بر تمدید حتمی خدمات ارائه شده به کاربران قبلی (پس از پایان اعتبار محصول) و یا ایجاد محصول برای متقاضیان جدید، ندارد. در صورت کامل نبودن اطلاعات، تا زمان کامل شدن آن مسئولیت عدم ثبت درخواست به عهده متقاضی خواهد بود. دارنده محصول شخصاً موظف به حفظ محصول و اطلاعات مربوط می باشد و هرگونه ادعا مبنی بر فقدان آن و یا سوء استفاده از طریق غیر (شخص / شرکت ثالث) پذیرفته نیست. وب سایت ها در قبول و یا رد کارت صادرشده مختار بوده و هیچگونه مسئولیتی در ارتباط با عدم پذیرفته شدن کارت متوجه سایت و صادر کننده نخواهد بود.<br /> استفاده از محصول و کلیه حقوق و بهره برداری از آن متعلق به دارنده اصلی محصول می باشد و هرگونه استفاده از محصول توسط شخص و اشخاص حقیقی و حقوقی دیگر تخلف میباشد و اشخاص مذکور متخلف محسوب می شوند و علاوه بر توقف ارائه خدمات موجب جریمه نقدی نیز خواهند شد. پرداخت کلیه هزینه های رایج محصول به عهده درخواست کننده می باشد.<br />در صورتی که مشکلی در هنگام پرداخت از سمت سایت مورد نظر خریدار، رخ دهد، مبلغ پرداخت شده از طرف مشتری مطابق قوانین سایت مذکور می گردد و مشتری می بایست مستقیما از سایت مذکور پیگیری نماید.<br />این سایت هیچگونه مسئولیتی در مورد پرداخت هایی که از طرف مشتری لغو می گردد اعم از کنسل و یا ریفاند و یا از طرف مشتری و یا فروشنده پس از انجام خرید و خروج مبلغ از حساب ما به هر علتی برگشت داده می شود، نخواهد داشت و مبلغ برگشتی غیرقابل استرداد به مشتری می باشد. لذا مشتری باید قبل از درخواست سرویس و واریز وجه به حساب های ما این مساله را مد نظر گرفته و با علم به این موضوع نسبت به انجام خرید آنلاین خود اقدام کند.<br />در پرداخت پی پال، وب سایت پی پال از گیرنده مبلغی را بابت حق عملیات ارسال وجه کسر می نماید که این مبلغ طبق قوانین پی پال به عهده گیرنده است نه فرستنده. قاعدتاً ما مسئولیت پرداخت های پی پال هایی را که شما مایل به لغو کردن آن ها هستید را به عهده نخواهیم گرفت و پس از پرداخت توسط پی پال پرداخت انجام شده را لغو نخواهیم کرد.<br />توجه :<br />طبق قوانین و شرایط ذکر شده در این صفحه سفارش هر کدام از محصولات و خدمات ما به منزله پذیرش این شرایط می باشد، لذا دقت نمایید، پس از ثبت سفارش به هیچ عنوان مبلغ پرداخت شده قابل عودت نبوده و وجه آن به هیچ عنوان مسترد نخواهد شد.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default withRouter(CollectionLeftSidebar);